import React, { Component } from 'react'

import PropTypes from 'prop-types'
import getByPath from 'lodash/get'
import config from '../../config'
import CommentList from './CommentList'

export default class Note extends Component {
  static propTypes = {
    data: PropTypes.object,
    customizedPlanId: PropTypes.string
  }

  static defaultProps = {
    data: {},
    customizedPlanId: ''
  }

  constructor(props) {
    super(props)

    this.state = {
      isOpen: true
    }
  }

  htmlDecode(input){
    var e = document.createElement('div');
    e.innerHTML = input;
    return e.childNodes.length === 0 ? "" : e.childNodes[0].nodeValue;
  }

  renderNoteDetails() {
    const photo = getByPath(this.props, 'data.note.defaultPhoto', [])

    const imgStyle = {
      backgroundImage: `url(${photo.s3Url})`
    }
    const imgsrc = photo.s3Url;

    return (
      <div style={{ marginTop: 10 }}>
        {photo && 
          <div className="event__photos">
            <div className="event__photo">           
              <img src={imgsrc} style={{ height: 230, width: 230 }}></img>
            </div>
          </div>
        }

        <div className="plan-part__search-result search-result">
          <div style={{wordBreak: 'normal'}} className="search-result__title" dangerouslySetInnerHTML={{ __html: this.props.data.note.content }} />
        </div>

        <CommentList noteId={this.props.data.note.id} customizedPlanId={this.props.customizedPlanId} user={this.props.user}/>
      </div>
    )
  }

  render() {
    return (
      <div className="trip-date__event">
        <span
          className="event__title"
          onClick={() => {
            this.setState(state => ({
              isOpen: !state.isOpen
            }))
          }}
        >
          {this.props.data.title}
        </span>
        {this.state.isOpen && this.renderNoteDetails()}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// src/components/MyTrip/Note.js